export const DEFAULT_BUSINESS_CASE_OFFER_EXPIRING_DAYS = 3;
